<template>
  <div class="flex flex-col gap-8">
    <div class="flex flex-col gap-1">
      <span class="text_color text-xl font-semibold">Assign AI Agent to channels</span>
      <span class="text-sm font-normal secondary_color">
        Enable or disable the AI agent for each support channel
      </span>
    </div>

    <div v-if="loading" class="flex justify-center py-10">
      <CustomLoader />
    </div>

    <div v-else class="flex flex-col gap-6">
      <div class="flex flex-col gap-6">
        <div class="flex items-center gap-3">
          <a-switch
            size="small"
            v-model:checked="livechatEnabled"
          />
          <span class="text_color text-sm font-medium">Livechat</span>
        </div>

        <div class="flex items-center gap-3">
          <a-switch
            size="small"
            v-model:checked="whatsappEnabled"
          />
          <span class="text_color text-sm font-medium">WhatsApp</span>
        </div>
      </div>

      <div class="flex justify-start">
        <a-button
          class="primary_medium"
          :loading="saving"
          @click="handleSave"
        >
          Save Changes
        </a-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { message } from "ant-design-vue";
import CustomLoader from "@/src/components/CustomLoader.vue";
import ConversationService from "@/src/api/ConversationService.js";

const loading = ref(false);
const saving = ref(false);
const livechatEnabled = ref(false);
const whatsappEnabled = ref(false);

const fetchSettings = async () => {
  try {
    const response = await ConversationService.getAgentChannelSettings();
    if (response && response.success && response.data) {
      for (const setting of response.data) {
        if (setting.channel === "livechat") {
          livechatEnabled.value = setting.bot_enabled;
        } else if (setting.channel === "whatsapp") {
          whatsappEnabled.value = setting.bot_enabled;
        }
      }
    }
  } catch (error) {
    console.error("Error fetching agent channel settings:", error);
  }
};

const handleSave = async () => {
  try {
    saving.value = true;
    const response = await ConversationService.updateAgentChannelSettings({
      channels: [
        { channel: "livechat", bot_enabled: livechatEnabled.value },
        { channel: "whatsapp", bot_enabled: whatsappEnabled.value },
      ],
    });

    if (response && response.success) {
      message.success("Settings saved successfully");
    } else {
      message.error("Failed to save settings");
    }
  } catch (error) {
    console.error("Error saving agent channel settings:", error);
    message.error("An error occurred while saving settings");
  } finally {
    saving.value = false;
  }
};

onMounted(async () => {
  loading.value = true;
  try {
    await fetchSettings();
  } finally {
    loading.value = false;
  }
});
</script>
